/**
 * @generated SignedSource<<3c130ac8f3d184527ea8e9e0599a85a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type LabelType = "ADMIN" | "SYSTEM";
import { FragmentRefs } from "relay-runtime";
export type LabelListRow_label$data = {
  readonly id: string;
  readonly name: string;
  readonly type: LabelType;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
  readonly " $fragmentType": "LabelListRow_label";
};
export type LabelListRow_label$key = {
  readonly " $data"?: LabelListRow_label$data;
  readonly " $fragmentSpreads": FragmentRefs<"LabelListRow_label">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LabelListRow_label",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SortableEntityTableRow_entity"
    }
  ],
  "type": "Label",
  "abstractKey": null
};

(node as any).hash = "2ce363f06dd85396ff4519b62bc55d70";

export default node;
